module.exports = __webpack_public_path__ + "static/media/entity-viewer.5045bab4.png";